import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" /></g>,<defs key="1"></defs>,]
, 'ControlsChevronRightx');
